import type { PlatformServices } from '../../platformContracts';
import { platformAnalytics, platformDashboard, platformSession } from './insights';
import { platformTenants } from './tenants';
import { platformFeatures } from './features';
import { platformPlans } from './plans';
import { platformUsers } from './users';
import { platformSubscriptions, platformPayments } from './billing';
import { platformAudit } from './audit';
import { platformSettings } from './settings';

export const mockPlatformServices: PlatformServices = {
  session: platformSession,
  dashboard: platformDashboard,
  tenants: platformTenants,
  features: platformFeatures,
  plans: platformPlans,
  users: platformUsers,
  subscriptions: platformSubscriptions,
  payments: platformPayments,
  analytics: platformAnalytics,
  audit: platformAudit,
  settings: platformSettings,
};

export { resetPlatform } from './context';
